import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Box } from '@mui/material';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import About from './components/About';
import Experience from './components/Experience';
import ProjectHighlights from './components/ProjectHighlights';
import Achievements from './components/Achievements';
import Skills from './components/Skills';
import Education from './components/Education';
import WestAfricaExpertise from './components/WestAfricaExpertise';
import Contact from './components/Contact';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0968E5',
    },
    secondary: {
      main: '#091970',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: '"Figtree", "Roboto", "Arial", sans-serif',
    h1: {
      fontFamily: '"Figtree", sans-serif',
      fontWeight: 700,
    },
    h2: {
      fontFamily: '"Figtree", sans-serif',
      fontWeight: 700,
    },
    h3: {
      fontFamily: '"Figtree", sans-serif',
      fontWeight: 700,
    },
    h4: {
      fontFamily: '"Figtree", sans-serif',
      fontWeight: 600,
    },
    h5: {
      fontFamily: '"Figtree", sans-serif',
      fontWeight: 600,
    },
    h6: {
      fontFamily: '"Figtree", sans-serif',
      fontWeight: 600,
    },
    body1: {
      fontFamily: '"Figtree", sans-serif',
      fontWeight: 400,
    },
    body2: {
      fontFamily: '"Figtree", sans-serif',
      fontWeight: 400,
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Navigation />
      <Box sx={{ width: '100%', overflowX: 'hidden' }}>
        <Box id="hero">
          <Hero />
        </Box>
        <Box id="about">
          <About />
        </Box>
        <Box id="experience">
          <Experience />
        </Box>
        <Box id="projects">
          <ProjectHighlights />
        </Box>
        <Box id="achievements">
          <Achievements />
        </Box>
        <Box id="skills">
          <Skills />
        </Box>
        <Box id="education">
          <Education />
        </Box>
        <Box id="expertise">
          <WestAfricaExpertise />
        </Box>
        <Box id="contact">
          <Contact />
        </Box>
      </Box>
    </ThemeProvider>
  );
}

export default App;

